import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import { DeviationLink } from '@wix/da-shared-react/pkg/Duperbrowse';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import s from './Commentable.scss';

export interface Props {
  deviation: PapiDeviation;
}

const Deviation: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const {
    author,
    title = t([
      `commentable.title.${getDeviationType(deviation)}.unknown`,
      'commentable.title.deviation.unknown',
    ]),
  } = deviation;

  let inner;
  if (author) {
    inner = t('commentable.header.genericWithAuthor', {
      postProcess: ['reactPostprocessor', 'featureBrancher'],
      title: (
        <DeviationLink className={s['link']} deviation={deviation}>
          {title}
        </DeviationLink>
      ),
      author: <UserLink className={s['link']} user={author} />,
    });
  } else {
    inner = t('commentable.header.generic', {
      postProcess: ['reactPostprocessor', 'featureBrancher'],
      title: (
        <DeviationLink className={s['link']} deviation={deviation}>
          {title}
        </DeviationLink>
      ),
    });
  }

  return <h1 className={s['text']}>{inner}</h1>;
};
Deviation.displayName = 'Deviation';

export default Deviation;
